export default {"src":"/_next/static/media/1.49ca3026.svg","height":171,"width":304,"blurWidth":0,"blurHeight":0};